import Vue from "vue";

Vue.filter('capitalise', (string) => {
  if (!string) {
    return '';
  }

  string = string.toLowerCase();
  string = string.split(' ');

  for (let i = 0; i < string.length; i += 1) {
    string[i] = string[i].charAt(0).toUpperCase() + string[i].slice(1);
  }

  const result = string.join(' ');
  return result;
});
